module.exports = __webpack_public_path__ + "static/media/btn_actions_taken_1075_725.401445b7.png";